export function configureResourceWhitelist($sceDelegateProvider) {
    'ngInject';

    $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'https://**.meltwater.net/**',
        'https://**.meltwater.io/**',
        'https://**.meltwater.com/**'
    ]);

};


// WEBPACK FOOTER //
// ./src/lib/providers/app.resource-whitelist.config.ts